// import { computeHeadingLevel } from '@testing-library/react';
import React, {Component} from "react";
import {Navbar, Nav, NavDropdown} from "react-bootstrap";
import {getLang} from "../../actions/actions";
import Translate from "react-translate-component";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import counterpart from "counterpart";
import en from "../langs/en";
import ar from "../langs/ar";
import "./Navbar.css";
import "./NavbarAr.css";
counterpart.registerTranslations("en", en);
counterpart.registerTranslations("ar", ar);
var initLang;
var initDir;
var initTextAl;
// Check the language from the URL ex.(localhost:3000/#en)
if (window.location.hash.includes("#en")) {
  initLang = "en";
  initDir = "ltr";
  initTextAl = "left";
} else if (window.location.hash.includes("#ar")) {
  initLang = "ar";
  initDir = "rtl";
  initTextAl = "right";
} else {
  // Default Language
  initLang = "en";
  initDir = "ltr";
  initTextAl = "left";
}
counterpart.setLocale(initLang);
class NavbarC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      dir: initDir,
      lang: initLang,
      textAlign: initTextAl,
    };
    // To render the page's language
    this.props.getLang(this.state.lang, this.state.dir, this.state.textAlign);
  }
  // Change page's Language when change it
  onlangChange = (e) => {
    if (e.target.value === "en") {
      this.setState({
        dir: "ltr",
        lang: "en",
        textAlign: "left",
      });
    } else if (e.target.value === "ar") {
      this.setState({
        dir: "rtl",
        lang: "ar",
        textAlign: "right",
      });
    }
    this.setState({
      lang: e.target.value,
    });
    counterpart.setLocale(e.target.value);
    setTimeout(() => {
      this.props.getLang(this.state.lang, this.state.dir, this.state.textAlign);
    }, 100);
  };
  // Show dropdown items on hover  "onMouseEnter"
  showDropdown = (e) => {
    this.setState({
      show: true,
    });
  };
  // Hide dropdown items on hover "onMouseLeave"
  hideDropdown = (e) => {
    this.setState({
      show: false,
    });
  };
  // Change state.show to toggle class show
  toggleShow = () => {
    let dropDownMenu = document.querySelector(".dropdown-menu");
    dropDownMenu.classList.toggle("active");
  };
  render() {
    // console.log(this.props);
    const dropDownLink = <Translate content="navbar.navLinks.link2.title" />;
    const enOpt = (
      <Translate content="langs.en" component="option" value="en" />
    );
    const arOpt = (
      <Translate content="langs.ar" component="option" value="ar" />
    );
    return (
      <div className="navbar-container">
        <div className="overlay"></div>
        <div className="navPos">
          <div className="container">
            <Navbar collapseOnSelect expand="lg" variant="dark">
              <Navbar.Brand href="#">
                <Translate content="navbar.navLogo" />
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="responsive-navbar-nav" />
              <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="ml-auto">
                  <Link to="/" className="nav-link">
                    <Translate content="navbar.navLinks.link1" />
                  </Link>

                  <NavDropdown
                    title={dropDownLink}
                    id="collasible-nav-dropdown"
                    onClick={this.toggleShow}
                    show={this.state.show}
                    onMouseEnter={this.showDropdown}
                    onMouseLeave={this.hideDropdown}
                    onClick={this.toggleShow}
                  >
                    <Link to="/allCountries" className="dropdown-item">
                      <Translate content="navbar.navLinks.link2.subLinks.link1" />
                    </Link>
                    <Link to="/addCountry" className="dropdown-item">
                      <Translate content="navbar.navLinks.link2.subLinks.link2" />
                    </Link>
                  </NavDropdown>
                  <Link to="/companyProfile" className="nav-link">
                    <Translate content="navbar.navLinks.link3" />
                  </Link>
                </Nav>
                <Nav>
                  <select value={this.state.lang} onChange={this.onlangChange}>
                    {enOpt}
                    {arOpt}
                  </select>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </div>
        </div>
        <div className="title-container">
          <Translate content="mainWebPageHead" component="h1" />
        </div>
      </div>
    );
  }
}
// function mapDispatchToProps(dispatch) {
//   return {
//     getLang: () => dispatch(getLang()),
//   };
// }
export default connect(null, {getLang})(NavbarC);
